import _ from "@lodash";
import { Avatar, Divider, Paper, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import ConfirmacaoApp from "app/Core/Components/Confirmacao/ConfirmacaoApp";
import MensagemAgendamento from "app/Core/Components/Mensagem/MensagemAgendamento";
import TagBullet from "app/Core/Components/TagBullet/TagBullet";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import EmpresaPessoaToggleButton from "app/ERP/EmpresaPessoa/Components/EmpresaPessoaToggleButton";
import TarefaApontamentoApp from "app/Workflow/TarefaApontamento/TarefaApontamentoApp";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { MdMail, MdPhone, MdPhoneAndroid } from "react-icons/md";
import { RiCake2Line } from "react-icons/ri";
import Alertas from "./Alertas/Alertas";
import ContatoStatus from "./ContatoStatus";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    divProfile: {
        //background: 'linear-gradient(to right, ' + theme.palette.primary.dark + ' 0%, ' + theme.palette.primary.main + ' 100%)',
        minHeight: 150,
        minWidth: 150
    },
    textColor: {
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
    },
    toolbar: {
        background: theme.palette.type === "dark" ? "#303030" : "#E6E6E6",
        borderRadius: "4px 4px 0 0"
    },
    divStatus: {
        borderTop: "1px solid " + theme.palette.type === "dark" ? "#303030" : "#E6E6E6",
    }
});

class Contato extends XAPPComponent {

    state = {
        showObservacao: false,
        observacao: ""
    };

    componentDidMount() {
        const { data = null } = this.props;
        this.setState({ observacao: !_.isNull(data) ? data.observacao : "" });
    }

    getTags = () => {
        const { data, TagsPessoa = null } = this.props;
        let AResponse = [];
        if (!_.isNull(TagsPessoa) && TagsPessoa.length > 0 && !_.isUndefined(data.tags) && !_.isNull(data.tags)) {
            TagsPessoa.forEach(tag => {
                if (data.tags.includes(tag.codigo)) {
                    AResponse.push({ "id": tag.idtagpessoaformulario, "title": tag.tagnome, "color": tag.cor });
                }
            });
        }
        return AResponse;
    };

    render() {
        const { data = null, classes, get, xappRouteParams, handleChange = null, agendamento = null, save, STATUS, saveAgendamentoPessoa, showTitle = false, showPedido = true, showChat = true, showConfirmar = true } = this.props;
        let ADateSplit = [];
        if (!_.isNull(data) && !_.isNull(data.nascimentoabertura) && !_.isUndefined(data.nascimentoabertura)) {
            ADateSplit = data.nascimentoabertura.split("/");
        }

        return (
            <Paper className={clsx(classes.divProfile, "flex flex-col items-center justify-center w-full md:justify-start mt-8")}>
                <div className={clsx(classes.toolbar, "w-full flex flex-row items-center")}>
                    {showTitle &&
                        <React.Fragment>
                            <Typography className="ml-8 capitalize" color="action">{this.getDicionario("cliente", "cliente")}</Typography>
                            <div className="flex-1" />
                        </React.Fragment>
                    }
                    <Alertas
                        idfontepagadora={agendamento.preatendimento.idfontepagadora}
                        idpessoaformulario={data.idpessoaformulario}
                        xappRouteParams={xappRouteParams}
                        className=""
                        color="action"
                    />
                    {!_.isNull(agendamento.idagendamento) && !_.isNull(data.idagendamentopessoaformulario) && showChat &&
                        <MensagemAgendamento
                            idfuncionalidade={data.idagendamentopessoaformulario}
                            xappRouteParams={xappRouteParams}
                            className={clsx(classes.textColor, "text-18")}
                            header={agendamento.iniciodescricao + " - " + data.nome}
                        />
                    }
                    <EmpresaPessoaToggleButton
                        xappRouteParams={xappRouteParams}
                        idpessoaformulario={data.idpessoaformulario}
                        iconProps={clsx(classes.textColor, "text-18")}
                        callback={() => get(agendamento.idagendamento, xappRouteParams)}
                    />
                    {//!_.isNull(agendamento.idagendamento) && !_.isNull(data.idagendamentopessoaformulario) &&
                        < XAPPButton
                            tooltip={{ "title": (!this.state.showObservacao ? "Observações" : "Contatos"), "placement": "top" }}
                            type="icon"
                            className="p-8"
                            variant="contained"
                            color="textSecondary"
                            onClick={() => this.setState(_.set({ ...this.state }, "showObservacao", !this.state.showObservacao))}
                            iconProps={clsx(classes.textColor, "text-18")}
                            icon={!this.state.showObservacao ? "observacao" : "profile"}
                        />
                    }
                    {showConfirmar &&
                        <React.Fragment>
                            {data.confirmado === -1 ?
                                <ConfirmacaoApp
                                    id="ConfirmarAgendamento"
                                    tooltip={{ "title": "Confirmar", "placement": "top" }}
                                    type="icon"
                                    onConfirmation={() => save({
                                        idagendamentopessoaformulario: data.idagendamentopessoaformulario,
                                        idagendamento: agendamento.idagendamento
                                    }, xappRouteParams, "CONFIRMAR")}
                                    mensagem={`O(a) ${data.nome} selecionou a opção "Não Confirmar Agendamento". Após esta ação, o agendamento será confirmado e não poderá retornar ao estado anterior. Confirma esta ação?`}
                                    xappRouteParams={xappRouteParams}
                                    icon={"like"}
                                    iconProps={clsx(" text-red text-18")}
                                    className="p-8"
                                    variant="contained"
                                    color="textSecondary"
                                />
                                :
                                <XAPPButton
                                    tooltip={{ "title": data.confirmado === 1 ? "Desconfirmar" : "Confirmar", "placement": "top" }}
                                    type="icon"
                                    className="p-8"
                                    variant="contained"
                                    color="textSecondary"
                                    iconProps={clsx(data.confirmado === 1 ? "text-green" : classes.textColor, "text-18")}
                                    icon={"like"}
                                    onClick={() => save({
                                        idagendamentopessoaformulario: data.idagendamentopessoaformulario,
                                        idagendamento: agendamento.idagendamento
                                    }, xappRouteParams, "CONFIRMAR")}
                                />
                            }
                        </React.Fragment>
                    }
                    {!_.isNull(agendamento.idagendamento) && !_.isUndefined(save) && !_.isNull(data.idagendamentopessoaformulario) && showPedido &&
                        <React.Fragment>
                            {!_.isNull(data.idtarefaprocesso) ?
                                <TarefaApontamentoApp
                                    xappRouteParams={xappRouteParams}
                                    foreingKey={data.idtarefaprocesso}
                                    idpessoaformulario={data.idpessoaformulario}
                                    pessoaformulario={agendamento.fontepagadora}
                                    profissional={agendamento.responsaveisLookup[0]}
                                    apontamento={"4"}
                                    id={"TarefaApontamentoPedido_" + data.idtarefaprocesso}
                                    key={"TarefaApontamentoPedido_" + data.idtarefaprocesso}
                                    showDialog={true}
                                    callback={() => {
                                        if (![4, 9, 10, 11].includes(data.status)) {
                                            save(agendamento, xappRouteParams, "ATUALIZAR");
                                        }
                                    }}
                                >
                                    <XAPPButton
                                        tooltip={{ "title": "Pedidos", "placement": "top" }}
                                        type="icon"
                                        className="p-8"
                                        variant="contained"
                                        color="textSecondary"
                                        iconProps={clsx(classes.textColor, "text-18")}
                                        icon={"shopping"}
                                        onClick={() => { }}
                                    />
                                </TarefaApontamentoApp>
                                :
                                <React.Fragment>
                                    {![5, 6, 7].includes(data.status) &&
                                        <XAPPButton
                                            tooltip={{ "title": "Gerar pedido", "placement": "top" }}
                                            type="icon"
                                            className="p-8"
                                            variant="contained"
                                            color="textSecondary"
                                            iconProps={clsx(classes.textColor, "text-18")}
                                            icon={"shopping_add"}
                                            onClick={() => save({ ...agendamento, idagendamentopessoaformulario: data.idagendamentopessoaformulario }, xappRouteParams, "INICIARFLUXO")}
                                        />
                                    }
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                    {!_.isNull(agendamento.idagendamento) && !_.isNull(data.idtarefaprocesso) && !_.isUndefined(save) && !_.isNull(data.idtarefaprocessoapontamento) && showPedido &&
                        <TarefaApontamentoApp
                            xappRouteParams={xappRouteParams}
                            foreingKey={data.idtarefaprocesso}
                            idpessoaformulario={data.idpessoaformulario}
                            idtarefaprocessoapontamento={data.idtarefaprocessoapontamento}
                            pessoaformulario={data}
                            profissional={agendamento.responsaveisLookup[0]}
                            apontamento={"4"}
                            id={"TarefaApontamentoReceber_" + data.idtarefaprocesso}
                            key={"TarefaApontamentoReceber_" + data.idtarefaprocesso}
                            showDialog={false}
                            openFirstItem={true}
                            callback={() => {
                                if (![4, 9, 10,11].includes(data.status)) {
                                    save(agendamento, xappRouteParams, "ATUALIZAR");
                                }
                            }}
                        >
                            <XAPPButton
                                tooltip={{ "title": "Receber", "placement": "top" }}
                                type="icon"
                                className="p-8"
                                variant="contained"
                                color="textSecondary"
                                iconProps={clsx(classes.textColor, "text-18")}
                                icon={"cifrao"}
                                onClick={() => { }}
                            />
                        </TarefaApontamentoApp>
                    }
                    <Divider className="w-px ml-4 mr-8 h-32" />
                    <div className={clsx(!showTitle && "flex-1")} />
                    {!_.isNull(agendamento.idagendamento) && !_.isNull(data.idagendamentopessoaformulario) &&
                        <ContatoStatus
                            iconProps={clsx(classes.textColor, "text-18")}
                            xappRouteParams={xappRouteParams}
                            save={save}
                            data={{ ...agendamento, ...data }}
                            STATUS={STATUS}
                            callback={() => { }}
                        />
                    }
                </div>
                <div className="w-full flex flex-row h-full items-center p-12">
                    <Avatar className="w-96 h-96" src={data.foto ? data.foto : "assets/images/avatars/profile.png"} />
                    <div className="flex w-full items-center">
                        <div className="block items-center w-full">
                            <TagBullet
                                className="ml-16 mr-4"
                                itens={this.getTags()}
                            />
                            <div className="flex flex-row items-center mt-8">
                                <Typography className={clsx(classes.textColor, "ml-16 mr-4")} color="textSecondary">{data.nome}</Typography>
                            </div>
                            <div className="flex flex-row items-center mt-8">
                                {!_.isUndefined(data.nascimentoabertura) && !_.isNull(data.nascimentoabertura) && data.nascimentoabertura !== "" &&
                                    <Typography className={clsx(classes.textColor, "ml-16 mr-4 white")} color="textSecondary">{"Data de nascimento: " + data.nascimentoabertura}</Typography>
                                }
                                {_.isEqual(new Date().getMonth(), new Date(+ADateSplit[2], ADateSplit[1] - 1, +ADateSplit[0]).getMonth()) &&
                                    <RiCake2Line className="text-20 ml-16" />
                                }
                            </div>
                            <div className="flex flex-row items-center mt-8">
                                {!_.isUndefined(data.origem) && !_.isNull(data.origem) && data.origem !== "" &&
                                    <Typography className={clsx(classes.textColor, "ml-16 mr-4 white")} color="textSecondary">
                                        {"Origem: " + data.origem + (!_.isNull(data.origemdescricao) && data.origemdescricao !== "" ? (" [ " + data.origemdescricao + " ]") : "")}
                                    </Typography>
                                }
                            </div>
                            {this.state.showObservacao ?
                                <div className="flex flex-col w-full p-8">
                                    <TextField
                                        className=""
                                        label="Observações"
                                        name="observacao"
                                        value={this.state.observacao}
                                        onChange={ev => {
                                            this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
                                            if (!_.isNull(handleChange)) {
                                                handleChange(ev);
                                            }
                                        }}
                                        variant="outlined"
                                        multiline
                                        rows={2}
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {!_.isNull(agendamento.idagendamento) &&
                                        <div className="flex w-full justify-end mt-8">
                                            <XAPPButton
                                                type="Button"
                                                className="text-white"
                                                variant="contained"
                                                color="primary"
                                                disabled={_.isNull(this.state.observacao) || this.state.observacao === ""}
                                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                                icon={"save"}
                                                label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                                onClick={() => {
                                                    saveAgendamentoPessoa({ ...data, observacao: this.state.observacao }, xappRouteParams);
                                                    //this.setState(_.set({ ...this.state }, "showObservacao", !this.state.showObservacao));
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                                :
                                <div className="flex flex-wrap w-full mx-8 mt-6">
                                    {data.fone && data.fone.length > 3 &&
                                        <a
                                            style={{ textDecoration: "none" }}
                                            className="font-medium flex items-center p-4"
                                            href={"tel:" + data.fone}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <MdPhone className="text-green text-20 mr-8" />
                                            <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.fone}</Typography>
                                        </a>
                                    }
                                    {data.celular && data.celular.length > 3 &&
                                        <a
                                            style={{ textDecoration: "none" }}
                                            className="font-medium flex items-center p-4"
                                            href={"tel:" + data.celular}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <MdPhoneAndroid className="text-green text-20 mr-8" />
                                            <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.celular}</Typography>
                                        </a>
                                    }
                                    {data.whatsapp && data.whatsapp.length > 3 &&
                                        <a
                                            style={{ textDecoration: "none" }}
                                            className="font-medium flex items-center p-4"
                                            href={"https://wa.me/" + data.whatsapp}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <FaWhatsapp className="text-green text-20 mr-8" />
                                            <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.whatsapp}</Typography>
                                        </a>
                                    }
                                    {data.email && data.email.length > 0 &&
                                        <a
                                            style={{ textDecoration: "none" }}
                                            className="font-medium flex items-center p-4"
                                            href={"mailto:" + data.email}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <MdMail className="text-yellow-dark text-20 mr-8" />
                                            <Typography className="text-14 xs:hidden sm:block whitespace-no-wrap mr-8" color="textSecondary">{data.email}</Typography>
                                        </a>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {showConfirmar && _.findIndex(STATUS, { id: data.status }) !== -1 &&
                    <div className={clsx(classes.divStatus, "flex w-full justify-end")}>
                        <Typography className={clsx(classes.textColor, "pr-8 pb-8 text-10")} color="textSecondary">{_.find(STATUS, { id: data.status }).label + " | " + (data.confirmado === 1 ? "Confirmado" : "Não confirmado")}</Typography>
                    </div>
                }
            </Paper>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Contato);